const ReadableStreamRef = typeof ReadableStream === "function" ? ReadableStream : function () {};
export class ChecksumStream extends ReadableStreamRef {}